import React, { Component } from 'react';

class IconDashboardWarning extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="none"
                viewBox="0 0 32 32"
            >
                <circle cx="16" cy="16" r="16" fill="#fff"></circle>
                <path
                    fill="#F8AC30"
                    d="M32 16a16 16 0 11-32 0 16 16 0 0132 0zM16 8a1.81 1.81 0 00-1.8 1.99l.7 7.014a1.104 1.104 0 002.2 0l.7-7.014A1.81 1.81 0 0016 8zm.004 12a2 2 0 100 4 2 2 0 000-4z"
                ></path>
            </svg>
        );
    }
}

export default IconDashboardWarning;